module.exports = __webpack_public_path__ + "static/IMG_2859.150660c7.JPG";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/accueil/nouveau/IMG_2859.JPG
// module id = 906
// module chunks = 3